/* KST skin quiz: side effects (analytics, Klaviyo, cart). Never throws from tracking. */
(function (global) {
  'use strict';

  var KLAVIYO_EVENTS = {
    quiz_started: 'Quiz Started',
    email_submitted: 'Quiz Email Submitted',
    results_viewed: 'Quiz Results Viewed',
    routine_added: 'Quiz Routine Added To Cart'
  };
  var REVISION = '2024-10-15';

  function isObj(v) { return v !== null && typeof v === 'object' && !Array.isArray(v); }

  function create(root) {
    var r = root || {};

    function klaviyo(args) {
      try {
        r.klaviyo = r.klaviyo || [];
        r.klaviyo.push(args);
      } catch (e) { /* Klaviyo unavailable: quiz continues */ }
    }

    function normalizePhone(raw) {
      if (typeof raw !== 'string') return null;
      var d = raw.replace(/\D/g, '');
      if (d.length === 10) return '+1' + d;
      if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
      return null;
    }

    function klaviyoProps(answers) {
      var out = {};
      if (!isObj(answers)) return out;
      Object.keys(answers).forEach(function (k) {
        var v = answers[k];
        out['kq_' + k] = Array.isArray(v) ? v.join(',') : v;
      });
      return out;
    }

    function subscriptionBody(lead, listId) {
      var attrs = {
        email: lead.email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };
      if (lead.sms && lead.phone) {
        attrs.phone_number = lead.phone;
        attrs.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'KST Skin Quiz',
            profile: { data: { type: 'profile', attributes: attrs } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
    }

    function track(name, props) {
      if (typeof name !== 'string' || !name) return;
      var payload = isObj(props) ? props : {};
      try {
        if (r.Shopify && r.Shopify.analytics && typeof r.Shopify.analytics.publish === 'function') {
          r.Shopify.analytics.publish('kq_' + name, payload);
        }
      } catch (e) { /* analytics must never break the quiz */ }
      try {
        if (Array.isArray(r.dataLayer)) r.dataLayer.push(Object.assign({ event: 'kq_' + name }, payload));
      } catch (e) { /* ignore */ }
      gaEvent('kq_' + name, payload);
      if (KLAVIYO_EVENTS[name]) klaviyo(['track', KLAVIYO_EVENTS[name], payload]);
    }

    // GA4 (gtag.js) ignores plain objects pushed to dataLayer; it only reads gtag() calls.
    // Before gtag.js defines window.gtag, queue the call the way its own snippet does.
    function gaEvent(eventName, payload) {
      var params = {};
      Object.keys(payload).forEach(function (k) {
        // "value" is GA4's numeric event value; an answer string there is misread.
        params[k === 'value' ? 'answer_value' : k] = payload[k];
      });
      try {
        if (typeof r.gtag === 'function') r.gtag('event', eventName, params);
        else if (Array.isArray(r.dataLayer)) r.dataLayer.push(gtagArgs('event', eventName, params));
      } catch (e) { /* ignore */ }
    }

    function gtagArgs() { return arguments; }

    function captureLead(opts) {
      var o = isObj(opts) ? opts : {};
      var lead = isObj(o.lead) ? o.lead : {};
      if (!lead.email) return Promise.resolve(false);
      var ident = Object.assign({ email: lead.email }, klaviyoProps(o.answers));
      if (lead.phone) ident.phone_number = lead.phone;
      klaviyo(['identify', ident]);
      if (!o.companyId || !o.listId) {
        console.warn('kst-quiz: Klaviyo list ID not set; skipping subscribe');
        return Promise.resolve(false);
      }
      if (typeof r.fetch !== 'function') return Promise.resolve(false);
      var p;
      try {
        p = r.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(o.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
          body: JSON.stringify(subscriptionBody(lead, o.listId))
        });
      } catch (e) {
        console.warn('kst-quiz: ' + ((e && e.message) || String(e)));
        return Promise.resolve(false);
      }
      return Promise.resolve(p).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo subscribe failed: ' + res.status);
        return true;
      }).catch(function (e) {
        console.warn('kst-quiz: ' + ((e && e.message) || String(e)));
        return false;
      });
    }

    function cartRoot() {
      return (r.Shopify && r.Shopify.routes && r.Shopify.routes.root) || '/';
    }

    function postJSON(url, body) {
      if (typeof r.fetch !== 'function') return Promise.reject(new Error('Cart unavailable'));
      var p;
      try {
        p = r.fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      } catch (e) {
        return Promise.reject(e);
      }
      return Promise.resolve(p).then(function (res) {
        if (res.ok) return res.json();
        return res.json().catch(function () { return {}; }).then(function (j) {
          throw new Error((j && (j.description || j.message)) || ('Cart request failed: ' + res.status));
        });
      });
    }

    function addRoutine(payload) {
      if (!isObj(payload) || !Array.isArray(payload.items) || payload.items.length === 0) {
        return Promise.reject(new Error('No products to add'));
      }
      var updates = {};
      var ids = {};
      payload.items.forEach(function (it) {
        updates[String(it.id)] = it.quantity;
        ids[String(it.id)] = true;
      });
      (Array.isArray(payload.remove) ? payload.remove : []).forEach(function (id) {
        if (!ids[String(id)]) updates[String(id)] = 0;
      });
      // One idempotent request: sets quantities rather than adding, so a retry never stacks.
      return postJSON(cartRoot() + 'cart/update.js', { updates: updates, attributes: payload.attributes || {} });
    }

    return {
      normalizePhone: normalizePhone,
      klaviyoProps: klaviyoProps,
      subscriptionBody: subscriptionBody,
      track: track,
      captureLead: captureLead,
      addRoutine: addRoutine
    };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { create: create };
  else global.KstQuizIntegrations = create(global);
})(typeof window !== 'undefined' ? window : this);
